import React, {useContext, useEffect, useState} from "react";
import Snippet from "./Snippet";
import UserContext from "../../context/UserContext";
import "./Home.scss";
import SnippetEditor from "./SnippetEditor";
import {Link} from "react-router-dom";

import domain from "../../util/domain";
const axios = require('axios').default;

function Home() {
    const [snippets, setSnippets] = useState([]);
    const [newSnippetEditorOpen, setNewSnippetEditorOpen] = useState(false);
    const [editSnippetData, setEditSnippetData] = useState(null);

    const {user} = useContext(UserContext);
    useEffect(() => {
        //get snippet
        if (!user) setSnippets([]);
        else getSnippets();
    }, [user]);
    async function getSnippets () {
        const snippetsRes = await axios.get(domain + "/snippet/");
        setSnippets(snippetsRes.data);
    }
    function editSnippet (snippetData) {
        setEditSnippetData(snippetData);
        setNewSnippetEditorOpen(true)
    }
    function renderSnippets() {
        let sortedSnippets = [...snippets];
        sortedSnippets = sortedSnippets.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt);
        })
        return sortedSnippets.map((snippet, i) => {
            return <Snippet key={i} snippet={snippet} getSnippets={getSnippets}  editSnippet={editSnippet}/>
        })
    }


    return (
        <div className="home">
            {!newSnippetEditorOpen && user && (<button className="btn-editor" onClick={() => setNewSnippetEditorOpen(true)}>
                Add Snippet
            </button>)}
            {newSnippetEditorOpen && user && (
              <SnippetEditor setNewSnippetEditorOpen={setNewSnippetEditorOpen}
                             getSnippets={getSnippets}
                editSnippetData={editSnippetData}/>
            )}
        {snippets.length > 0 && renderSnippets()}
            {
               user === null && (
                   <div className="no-user-message"><h2>Welcome to MedAid, Lets explore!</h2>
                       <Link to="/register">Register here</Link></div>
               )
            }
    </div>)
}

export default Home;